<script>

</script>

<section>
    <h2>Limitations</h2>
    <section>
        <div>
            <ul>
                <li class="fragment fade-in" data-fragment-index="1">dense areas</li>
                <li class="fragment fade-in" data-fragment-index="2">outliers</li>
                <li class="fragment fade-in" data-fragment-index="3">exteme outliers</li>
            </ul>
        </div>
        <div class="r-stack">
            <img class="fragment fade-in-then-out" data-fragment-index="1" src="./images/limitation_example_1.svg" alt="ex1" />
            <img class="fragment fade-in-then-out" data-fragment-index="2" src="./images/limitation_example_2.svg" alt="ex1" />
            <img class="fragment fade-in-then-out" data-fragment-index="3" src="./images/limitation_example_3.svg" alt="ex1" />
        </div>
        <aside class="notes">
            Hagrid has some limitations.✨
            very dense areas in some areas in a scatterplot produces artefacts in the final layout. 
            The dots are colored by the neighborhood preservation metric.
            But this is probably a problem for most gridifying algorithms.✨
            Hagrid does not work well with outliers. And even worse with✨
            extreme outliers.
            But, those are examples, where you probably have to rethink the dimensionality reduction output in the first place.
        </aside>
    </section>
</section>
